import "../../assets/css/main.css";
import { Component } from "react";
import LeftContent from "./LeftContent";
import Analysis from "./Analysis";
import { connect } from "react-redux";
import { updateAppConfigAction,fetchingTradeDataAction,updateTradeDataAction } from "../../redux/actions";
import { isDesktop} from "../../lib/helper";
import api from "../../lib/api";

const MAX_DATA_LENGTH = 102;

class Trading extends Component {
  constructor(props) {
    super(props);
    this.state = {
      trading_data: [],
      win_value: 0,
      psychological_indicators: 0,
      isOpen: true,
    };
  }

  async componentDidMount() {
    if (!this.props.memberReducer?.login_token) {
      return this.props.history.push('/login');
    }
     await this.getTradingData();
     await this.getNextData();
  }
  getNextData = async () => {
    await api.getNextTradingData().then((data) => {
      if (this.state.trading_data.length + data.length > MAX_DATA_LENGTH) {
        this.setState({
          trading_data: [
            ...this.state.trading_data.slice(data.length),
            ...data
          ]
        });
      } else {
        this.setState({
          trading_data: [
            ...this.state.trading_data,
            ...data
          ]
        });
      }
    });
  };
   getTradingData = async () => {
    await api.getTradingData().then((data) => {
        this.setState({ trading_data: data });
      });
    };
  // componentDidUpdate(prevState) {
  //   if (prevState.trading_data !== this.state.trading_data) {
  //     const trading_data = Array.isArray(this.state.trading_data)
  //       ? this.state.trading_data
  //       : Object.values(this.state.trading_data);
  //     this.setState({ trading_data }, () => {
  //     });
  //   }
  // }
  onCloseModal = () => {
    this.props.updateAppConfigAction({ win_value: 0 });
  };
  handleToggleIncaditor = () => {
    this.setState({ isOpen: !this.state.isOpen });
  };
 
  render() {
    if (!this.props.memberReducer?.login_token) {
      return null;
    }
    
    let { trading_data } = this.state;
    let { win_value, } = this.props.memberReducer;
    let { is_show_transaction,streak } = this.props.appReducer;
    return (
      <div data-v-b0e45e8c="" id="mainContent">
        <div data-v-b0e45e8c="" className="boxContent">
          <div data-v-5b2de64c="" data-v-b0e45e8c="" id="binaryPage">
            <section data-v-5b2de64c="" className="content position-relative">
              <div
                data-v-5b2de64c=""
                className={
                  "h-100 " +
                  (isDesktop() ? "d-flex flex-lg-row flex-md-row" : "")
                }
              >
                <LeftContent
                  trading_data={trading_data}
                  streak={streak}
                  win_value={win_value}
                  isOpen={this.state.isOpen}
                  is_show_transaction={is_show_transaction}
                  handleToggleIncaditor={this.handleToggleIncaditor}
                />
                <Analysis
                  trading_data={trading_data}
                  isOpen={this.state.isOpen}
                  handleToggleIncaditor={this.handleToggleIncaditor}
                />
              </div>
            </section>
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    memberReducer: state.memberReducer,
    appReducer: state.appReducer,
    trading_data: state.tradeReducer,
  };
}

export default connect(mapStateToProps, {
  updateAppConfigAction,
  fetchingTradeDataAction,
  updateTradeDataAction,
})(Trading);
